module.exports = __webpack_public_path__ + "static/media/6_Connect-Wires-to-Chime-Kit-2.65d5a951.svg";